// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"525":"78dd7645","828":"c1da6007","857":"41c1ca0b","962":"91e826c3"}[chunkId] + ".css";
};